import BaseModel from './base';

class AuthModel extends BaseModel {
	async login({ email, ...values }) {
		return this.post('/login', {
			body: { email: email.trim(), ...values },
			unauthorizedForceLogout: false
		});
	}

	async changePassword({ email, ...values }) {
		return this.post('/send-token', {
			body: { email: email.trim(), ...values }
		});
	}

	async updatePassword({ token, password }) {
		return this.post('/reset-password', {
			body: { token, password }
		});
	}

	async logout() {
		return this.get('/logout');
	}
}

export default new AuthModel('/auth');
